"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyApiSecurityHeaders = applyApiSecurityHeaders;
exports.buildApiSecurityHeaders = buildApiSecurityHeaders;
exports.createRequestNonce = createRequestNonce;
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
var _package = _interopRequireDefault(require("../../package.json"));
var _storageKeys = require("@/constants/storageKeys");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/** 与后端 auth.api-security.sign-secret 保持一致 */
var SIGN_SECRET = 'YxkjAdminApiSignKey2026';
var APP_ID = 'yx-admin-web';
var CLIENT_TYPE = 'admin-web';
var REQUEST_SOURCE = 'admin-ui';
var DEVICE_ID_KEY = _storageKeys.StorageKeys.ADMIN_DEVICE_ID;
function createRequestNonce() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
function getOrCreateDeviceId() {
  try {
    var id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = createRequestNonce();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch (e) {
    return createRequestNonce();
  }
}
function resolveFullUrl(config) {
  var baseURL = config.baseURL || '';
  var url = config.url || '';
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  var base = baseURL.replace(/\/+$/, '');
  var path = url.replace(/^\/+/, '');
  return base ? "".concat(base, "/").concat(path) : "/".concat(path);
}
function resolveRequestPath(config) {
  var full = resolveFullUrl(config);
  try {
    return new URL(full, window.location.origin).pathname;
  } catch (e) {
    var url = config.url || '';
    var pathOnly = url.split('?')[0];
    return pathOnly.startsWith('/') ? pathOnly : "/".concat(pathOnly);
  }
}

/**
 * 合并 URL 内嵌 query 与 config.params，按 key 排序后参与签名。
 * 后端 ApiSecurityFilter 从 request.getParameterMap() 取参，两者必须一致。
 */
function buildSortedQuery(config) {
  var merged = {};
  try {
    var full = resolveFullUrl(config);
    var parsed = new URL(full, window.location.origin);
    parsed.searchParams.forEach(function (value, key) {
      merged[key] = value;
    });
  } catch (e) {
    // ignore malformed url
  }
  var params = config.params;
  if (params && _typeof(params) === 'object') {
    Object.keys(params).forEach(function (key) {
      if (params[key] === undefined || params[key] === null) {
        return;
      }
      merged[key] = params[key];
    });
  }
  return Object.keys(merged).sort().map(function (key) {
    return "".concat(key, "=").concat(merged[key]);
  }).join('&');
}
function buildSignContent(timestamp, nonce, method, path, query) {
  return [timestamp, nonce, method.toUpperCase(), path, query || ''].join('\n');
}
function signRequest(signContent) {
  return _cryptoJs.default.HmacSHA256(signContent, SIGN_SECRET).toString(_cryptoJs.default.enc.Hex);
}

/**
 * 生成大厂风格的 API 安全请求头（小红书/阿里云等均采用类似组合）
 */
function buildApiSecurityHeaders(config) {
  var timestamp = String(Date.now());
  var nonce = createRequestNonce();
  var method = config.method || 'GET';
  var path = resolveRequestPath(config);
  var query = buildSortedQuery(config);
  var signContent = buildSignContent(timestamp, nonce, method, path, query);
  var sign = signRequest(signContent);
  return {
    'X-Request-Id': nonce,
    'X-Timestamp': timestamp,
    'X-Nonce': nonce,
    'X-Client-Type': CLIENT_TYPE,
    'X-Client-Version': _package.default.version || '0.0.0',
    'X-App-Id': APP_ID,
    'X-Device-Id': getOrCreateDeviceId(),
    'X-Request-Source': REQUEST_SOURCE,
    'X-Platform': 'web',
    'X-Request-Sign': sign
  };
}
function applyApiSecurityHeaders(config) {
  var headers = buildApiSecurityHeaders(config);
  config.headers = config.headers || {};
  Object.assign(config.headers, headers);
  return config;
}